// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2XpR_","form":"styles_form__1rCwp"};